exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main[data-v-c3114dd0]{max-width:800px;margin:0 auto}.main .title[data-v-c3114dd0]{margin-top:20px;text-align:center;font-size:30px;font-family:PingFang SC-Medium, PingFang SC;font-weight:500;color:rgba(0,0,0,0.85);margin-bottom:16px}.main[data-v-c3114dd0] table{border:1px solid #ccc}.main[data-v-c3114dd0] table th{border:1px solid #ccc}.main[data-v-c3114dd0] table td{padding:10px 5px;border:1px solid #ccc}.main[data-v-c3114dd0] p img{max-width:800px}[data-v-c3114dd0] .wang-editor.w-e-toolbar{display:none !important}\n", ""]);

// exports
